import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type ReassignRemoteLockDoorsRequest = {
  clientId: string
  lockIds: string[]
}

const reassignRemoteLockDoors = async (data: ReassignRemoteLockDoorsRequest) => {
  const response = await authAPI.put(`/remote-lock/users/${data.clientId}`, {
    lockIds: data.lockIds,
  })
  return response.data
}

export const useReassignRemoteLockDoors = () =>
  useMutation({
    mutationFn: reassignRemoteLockDoors,
  })
